import * as React from 'react';
import { BaSeFooter } from '@base/react';
import { version as appVersion } from '../../../package.json';
import { useVersionsService } from '../../hooks/versions-service';

export const LayoutFooter = () => {
  const [version] = useVersionsService();

  return (
    <div>
      <BaSeFooter
        relationText=""
        systemName="Certificados"
        links={[
          {
            label: 'Conheça o Sebrae',
            link: 'https://www.sebrae.com.br/sites/PortalSebrae/canais_adicionais/conheca_quemsomos',
          },
          {
            label: 'O que fazemos',
            link: 'https://oqueosebraefaz.com.br/',
          },
          {
            label: 'Cursos Online e Gratuitos',
            link: 'https://www.sebrae.com.br/sites/PortalSebrae/cursosonline',
          },
          {
            label: 'Fale Conosco',
            link: 'https://www.sebrae.com.br/sites/PortalSebrae/faleconosco',
          },
          {
            label: 'Ouvidoria',
            link: 'https://sebrae.com.br/sites/PortalSebrae/ouvidoriasebrae',
          },
        ]}
        systemVersion={`v.${
          version?.['git.build.version'] ?? ''
        } - Back | v.${appVersion} - Front`}
        collapsedHeader="Conheça o Sebrae"
      ></BaSeFooter>
    </div>
  );
};
